var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "page" },
    [
      _c(
        "v-container",
        { attrs: { "grid-list-md": "" } },
        [
          _c(
            "v-layout",
            { attrs: { row: "", wrap: "" } },
            [
              _c("v-flex", { attrs: { xs12: "", md6: "" } }, [
                _c("div", { staticClass: "myBox bgw" }, [
                  _c(
                    "div",
                    { staticClass: "d-flex align-center" },
                    [
                      _c(
                        "v-icon",
                        { staticClass: "myAccent", attrs: { "x-large": "" } },
                        [_vm._v("mdi-clock-outline")]
                      ),
                      _c("h3", { staticClass: "ml-2 fontColor" }, [
                        _vm._v("Lieferzeiten"),
                      ]),
                    ],
                    1
                  ),
                  _vm.$store.getters.appconfig.loaded
                    ? _c("div", [
                        _c(
                          "div",
                          {
                            staticClass: "mt-4",
                            staticStyle: { "font-size": "1.2em" },
                          },
                          [
                            _c("oeffnungszeiten", {
                              attrs: {
                                "opening-hours":
                                  _vm.$store.getters.appconfig.delivery
                                    .openingHours,
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticStyle: { padding: "0 5px" } },
                          [
                            _c(
                              "v-btn",
                              {
                                staticClass: "text-none mt-8 mb-2 btn-df",
                                attrs: { block: "" },
                                nativeOn: {
                                  "&click": function ($event) {
                                    return _vm.$ebus.$emit("shortcutToFoodMenu")
                                  },
                                },
                              },
                              [_vm._v(" Jetzt bestellen! ")]
                            ),
                          ],
                          1
                        ),
                      ])
                    : _c(
                        "div",
                        { staticClass: "text-center" },
                        [
                          _c("v-progress-circular", {
                            attrs: { indeterminate: "", size: "34" },
                          }),
                        ],
                        1
                      ),
                ]),
              ]),
              _c(
                "v-flex",
                { attrs: { xs12: "", md6: "" } },
                [_c("Zahlungsarten", { attrs: { noborder: true } })],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }